import { useId } from 'react';
import { useLocale, useTranslations } from 'use-intl';
import { useLanguageName } from '../i18n/hooks';
import { useLocaleChoice } from '../i18n/provider';
import { Select } from './ui/input';

/** Выбор языка на экранах входа: сохраняется в этом браузере. Вошедший меняет язык в профиле. */
export function GuestLanguageSelect() {
  const t = useTranslations('common');
  const id = useId();
  const locale = useLocale();
  const languageName = useLanguageName();
  const { locales, setGuestLocale } = useLocaleChoice();
  if (locales.length < 2) return null;
  return (
    <label htmlFor={id} className="flex items-center gap-2 text-sm text-muted">
      {t('language')}
      <Select
        id={id}
        className="w-auto"
        value={locale}
        onChange={(event) => setGuestLocale(event.target.value)}
      >
        {locales.map((code) => (
          <option key={code} value={code} lang={code}>
            {languageName(code)}
          </option>
        ))}
      </Select>
    </label>
  );
}
